module.exports = __webpack_public_path__ + "static/media/3DPPA37.f3d08463.jpg";